import { Languages } from 'src/graphql/schema.graphql';
import { gql, GqlFragment } from 'src/utils/gql/query';

export const languagesGqlQuery: GqlFragment<{ languages: Languages[] }> = gql`
  query {
    languages(limit: -1) {
      code
      name
    }
  }
`;
